<template>
  <div class="wx-box">
    <div class="wx-top">
      <div class="wx-rank">
        <div class="top-nav">
          <span :class="rankTab==1?'active':''" @click="switchRank(1)">日排行</span>
          <span :class="rankTab==2?'active':''" @click="switchRank(2)">总排行</span>
        </div>
        <div class="wx-content wx-rank-scroll">
          <div class="wx-item" v-for="(rank,idx) in rankList">
            <div>{{parseInt(idx)+1}}</div>
            <div>
              <img :src="rank.avatar" v-if="rank.avatar" :title="rank.realname"/>
              <span v-else style="color: rgba(125, 133, 146, 1)">{{rank.realname}}</span>
            </div>
            <div>
              总 {{rank.num}}
            </div>
            <div>
              能 {{rank.yesNum}}
            </div>
            <div>
              不能 {{rank.noNum}}
            </div>
          </div>
        </div>
      </div>
      <div class="wx-phone ">
        <div  class="top-nav">
          <span>检索号码</span>
        </div>
        <div class="wx-content">
          <div class="wx-phone-tx">
            <span class="phone">{{model.phone}}</span>
            <span class="copy" :id="'d'+model.id" :data-clipboard-text="model.phone" v-if="model.phone" @click="copyUrl(model.id)">点击复制</span>
          </div>
          <div class="phone-tips">这个手机号能不能搜索得到司机的微信？</div>
          <div class="phone-check">
            <a-radio-group name="radioGroup" class="radioGroup" v-model:value="value">
             <div class="check-box">
               <a-radio value="1" style="color: #0A1629;font-size: 16px">能</a-radio>
             </div>
              <div  class="check-box">
              <a-radio value="0" style="color: #0A1629;font-size: 16px">不能</a-radio>
              </div>
            </a-radio-group>
          </div>
          <a-button type="primary" class="nex-btn" :style="{background:value==''?'#c1c1c1':''}" @click="nextPhone" :loading="loading">下一条</a-button>
        </div>
      </div>
    </div>
    <span class="zhu-tips">注：1，请求好友时请规范用语（建议每个微信一天不超过20个请求）2，请准确反馈检索结果（不发起好友请求的可适当增加检索数量）</span>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:true}"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :customHeaderRow="customHeaderRow"
      :customRow="customRow"
      class="j-table-force-nowrap">

      <span :slot="column.slots?column.slots.title:''"  v-for="column in columns">
          <slot :name="column.slots?column.slots.title:''">
              <span>
              {{column.titleName}}
            </span>
            <icon-font v-if="column.update" :type="'icon-xiugai'" @click="updatePlatform()"
                       style="cursor: pointer;width: 12px;"></icon-font>
          </slot>
        </span>

      <template :slot="column.scopedSlots?column.scopedSlots.customRender:''" slot-scope="text,record"  v-for="column in columns">
        <slot :name="column.scopedSlots?column.scopedSlots.customRender:''" v-bind="record" >

          <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text">
            <span class="tb-span-click" v-if="column.dataIndex=='nickName'" style="color:#1890ff;cursor: pointer" :id="'di'+record.driverId" :data-clipboard-text="record.nickName"  @click="copyUrl('i'+record.driverId)">{{text || '-'}}</span>
            <div v-else-if="column.dataIndex=='culeStr' || column.dataIndex=='culeStrList'">
              <div v-for="(s,idxc) in text.split(',')" style="cursor: pointer" :id="'df'+record.driverId+idxc" :data-clipboard-text="s"  @click="copyUrl('f'+record.driverId+idxc)">{{s}}</div>
            </div>
            <span v-else-if="column.dataIndex=='driverName'" @click="viewInfo(record)" style="color:#1890ff;cursor: pointer">{{text || '-'}}</span>
            <span v-else>{{text || '-'}}</span>
          </div>
        </slot>
      </template>

    </a-table>
    <driver-info ref="driverModel"></driver-info>
    <a-modal
      :width="540"
      :visible="visible"
      :footer="null"
      :closable="false"
      @cancel="visible=false"
    >
      <a-textarea :rows="6" style="width: 100%" v-model="phrases.content"></a-textarea>
      <div class="footer-box">
       <div class="footer-left">
         <span style="color: rgba(0, 0, 0, 1);font-size: 12px">插入</span>
         <span class="footer-platform" @click="followPlatform">平台名称</span>
       </div>
        <div>
          <a-button type="primary" style="height: 36px !important;" @click="subPhrses">确定</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import DriverInfo from "../../../dm3.0/driver/DriverInfo";
  import Clipboard from 'clipboard'
  import ATextarea from "ant-design-vue/es/input/TextArea";
  export default {
    name: 'WxForm',
    components: {
      ATextarea,
      DriverInfo
    },
    props: {

    },
    data () {
      return {
        value:'',
        rankTab:1,
        rankList:[

        ],
        dataSource:[],
        columns:[
          {
            title:'客户姓名',
            align:"center",
            width:100,
            dataIndex: 'driverName',
            scopedSlots: { customRender: 'driverNameSlot' },
          },{
            title:'线索名称',
            align:"center",
            width:100,
            dataIndex: 'culeStr',
            scopedSlots: { customRender: 'culeStrSlot' },
          },{
            titleName:'建议问候语',
            align:"center",
            width:500,
            dataIndex: 'culeStrList',
            scopedSlots: { customRender: 'culeStrListSlot' },
            slots: { title: 'culeStrListSpanSlot' },
            update:true
          },{
            title:'运营城市',
            align:"center",
            width:120,
            dataIndex: 'areaName',
            scopedSlots: { customRender: 'areaNameSlot' },
          },{
            title:'建议备注昵称',
            align:"center",
            width:260,
            dataIndex: 'nickName',
            scopedSlots: { customRender: 'nickNameSlot' },
          }
        ],
        model:{},
        loading:false,
        visible:false,
        phrases:{
          content:''
        }
      }
    },
    computed: {

    },
    created () {

    },
    methods: {
      edit () {
        this.model = {};
        this.value = '';
        this.loadRank();
        this.getRank();
        this.getPhrases();
      },customHeaderRow(conlumn){
        conlumn.forEach((e,index)=>{
          conlumn[index].className = 'header-class'
        })
      },customRow(record){
        return {
          class:"row-class"
        }
      },loadRank(){
        getAction("/dm/dmPhoneRetrieval/slectRetrievalRand",{type:this.rankTab}).then(res=>{
          if(res.success){
            this.rankList = []
            this.rankList =res.result;
          }
        })
      },switchRank(tab){
        this.rankTab = tab;
        this.loadRank();
      },getRank(){
        getAction("/dm/dmPhone/selectPhoneByRand").then(res=>{
          if(res.success){
           this.model = res.result;
           this.dataSource = this.model.driverList;
          }
        })
      },viewInfo(record){
        this.$refs.driverModel.disableSubmit = true;
        this.$refs.driverModel.showInfo(null,record.driverId,{s:'基本信息',leftTab:1,b:'返回司机列表'});
      },copyUrl(id){
        let _this = this
        let clipborad = new Clipboard('#d'+id);
        //复制成功
        clipborad.on('success', function() {
          _this.$message.success('复制成功！')
          clipborad.destroy();
        })
      },nextPhone(){
        if(this.value=='' || !this.model.id){
          return;
        }
        let param = {
          phoneId:this.model.id,
          wxFlag:this.value
        }
        this.loading = true;
        httpAction("/dm/dmPhoneRetrieval/add",param,"POST").then(res=>{
          if(res.success){
            this.value="";
            this.model = {};
            this.getRank();
            this.loadRank();
          }
        }).finally(() => {
          let taht = this;
          setTimeout(function(){
            taht.loading = false;
          },600);

        })
      },updatePlatform(){
          this.visible = true
      },followPlatform(){
        this.phrases.content = this.phrases.content+"『平台名称』";

      },getPhrases(){
        getAction("/dm/dmPhonePhrases/getPhrases").then(res=>{
          if(res.success){
            if(res.result){
              this.phrases = res.result
            }else{
              this.phrases.content = "你好，我是『平台名称』的车队长，请通过一下";
            }
          }
        })
      },subPhrses(){
        if(!this.phrases.content){
          return;
        }
        httpAction("/dm/dmPhonePhrases/add",this.phrases,"POST").then(res=>{
          if(res.success){
            this.getRank();
            this.visible = false;
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .wx-box{
    background: rgba(244, 249, 253, 1);
    font-size: 16px;
  }
  .wx-top{
    display: flex;
    padding: 24px;
    justify-content: space-between;
    .top-nav{
      color: rgba(10, 22, 41, 1);
      display: flex;
      gap: 12px;
      margin-bottom: 12px;
      margin-left: 24px;
      cursor: pointer;
    }
    .top-nav .active{
      color: rgba(63, 140, 255, 1);
    }
    .wx-rank-scroll{
      overflow-y: auto;
    }
    .wx-content{
      width: 504px;
      background: #fff;
      border-radius: 12px;
      height: 274px;
      .wx-item{
        margin:24px;
        display: flex;
        gap: 48px;
        /*font-weight: 700;*/
        color: rgba(0, 0, 0, 1);
        img{
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
      }
      .wx-phone-tx{
        text-align: center;
        padding: 24px;
        .phone{
          font-size: 24px;
          font-weight: 700;
          color: rgba(10, 22, 41, 1);
        }
        .copy{
          margin-left: 24px;
          color: rgba(63, 140, 255, 1);
          cursor: pointer;
        }
      }
      .phone-tips{
        text-align: center;
        color: #ff0000;
      }
      .phone-check{
        margin: 24px;
        .radioGroup{
          display: flex;
          gap: 24px;
          .check-box{
            width: 216px;
            height: 48px;
            border-radius: 12px;
            border: 1px solid rgba(228, 230, 232, 1);
            line-height: 48px;
            text-align: center;
            /deep/ .ant-radio-inner{
              width: 21px !important;
              height: 21px !important;
            }
            /deep/ .ant-radio-inner{
              border:2px solid  #0A1629 !important;
            }
            /deep/ .ant-radio-checked .ant-radio-inner{
              border:2px solid  #0A1629 !important;
            }
            /deep/ .ant-radio-inner::after{
              width:10px !important;
              height: 10px !important;
              top:3px !important;
              left: 3.5px !important;
            }
          }
        }

      }
    }
  }
  .nex-btn{
    margin: 0 24px;
    width: 456px;
    border-radius: 12px;
  }
  .zhu-tips{
    margin-left: 24px;
  }

  .j-table-force-nowrap{
    margin-top: 24px;
  }

  .footer-box{
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
  }
  .footer-left{
    height: 36px;
    padding: 3px;
  }
  .footer-platform{
    font-size: 12px;
    color: rgba(63, 140, 255, 1);
    padding: 5px 18px;
    border-radius: 18px;
    border: 1px solid rgba(63, 140, 255, 1);
    margin-left: 18px;
    cursor: pointer;
  }
  /deep/ .header-class{
    background: #fff !important;
    color: rgb(125, 133, 146) !important;
    height: 48px;
    text-align: center;

  }

  .table-div-text{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0 auto;
  }

  /deep/ .row-class{
    background: #fff !important;
    color: rgba(10, 22, 41, 1) !important;
    height: 48px;
    font-size: 16px;
  }
</style>